import { loaderActions } from './progressLoader.reducer';

const { loadingStart, loadingStop} = loaderActions;

export const isLoading =(value) => async (dispatch) => {
    value ? dispatch(loadingStart()) : dispatch(loadingStop())
};
